import React from 'react';
import { IconProps } from './types';

export const CaretDownIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M7 10l5 5 5-5z" />
  </svg>
);
